import React from "react";
import Loader from "../../Common/Loader";

function PocketMoneyTransactions({loading5, pocketMoneyTransactions}) {

    return (
        <>
            {/* <div className="border-top mt-1"></div> */}
            <div className="table-responsive">
                {loading5 ? (
                    <Loader /> 
                ) : (
                    <table className="table display data-table text-nowrap">
                        <thead>
                            <tr>
                            <th>Transaction Date</th>
                            
                            <th>Amount</th>
                            <th>Description</th>
                            <th>Transaction Type</th>
                            <th>Transaction Number</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            {pocketMoneyTransactions.length > 0 ? (
                                pocketMoneyTransactions.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {item.created_at?.long_date}
                                    </td>
                                    
                                    <td><span class="badge bg-teal">
                                            {item.type === "Deposit" ?
                                            <i class="fa fa-circle-arrow-up text-teal fs-9px fa-fw me-5px" style={{ color: "#28a745" }}></i>:
                                            <i class="fa fa-circle-arrow-down text-teal fs-9px fa-fw me-5px" style={{ color: "#dc3545" }}></i>
                                                
                                            }
                                        </span>
                                        UGX.{" "}
                                        {item.amount}</td>                   
                                   <td>{item.description}</td>
                                    <td>
                                        <span class="badge badge-primary">
                                        {item.account}
                                        </span>
                                    </td>
                                    <td>{item.transaction_number}</td>
                                   
                                </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No pocket money transactions yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
            
        </>

        
    );
}

export default PocketMoneyTransactions;
